import { IChatConversation, IChatMessage } from 'src/@types/chat';
import { TodoItem, TodoList } from 'src/requests/todos';
import { axios } from 'src/utils/axios';

import { Doc } from 'src/@types/docs';
import { SortByEnum } from 'src/features/GeneralSearch/shared/types';

export enum GeneralSearchResponseType {
  channel = 'channel',
  channelMessage = 'channelMessage',
  meeting = 'meeting',
  todo = 'todo',
  todoItem = 'todoItem',
  doc = 'doc',
  driveContent = 'driveContent',
}

type ChannelResult = {
  type: GeneralSearchResponseType.channel;
  data: IChatConversation[];
};

type MeetingResult = {
  type: GeneralSearchResponseType.meeting;
  data: IChatConversation[];
};

type ChannelMessageResult = {
  type: GeneralSearchResponseType.channelMessage;
  data: IChatMessage[];
};

type TodoItemResult = {
  type: GeneralSearchResponseType.todoItem;
  data: TodoItem[];
};

type TodoResult = {
  type: GeneralSearchResponseType.todo;
  data: TodoList[];
};

type DocResult = {
  type: GeneralSearchResponseType.doc;
  data: Doc[];
};

export type SearchResponseItem =
  | ChannelResult
  | MeetingResult
  | ChannelMessageResult
  | TodoItemResult
  | TodoResult
  | DocResult;

export type SearchResponse = SearchResponseItem[];

export async function generalSearchRequest(
  searchTerm: string,
  sortBy: SortByEnum,
): Promise<SearchResponse> {
  const { data } = await axios.get(
    `/search/global?q=${searchTerm}&sortBy=${sortBy}`,
  );
  return data;
}

export * as RolesRequests from './roles.requests';
